import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './resources/style.scss';
import Routing from './components/Routing';
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import LoadingIndicator from "./components/common/LoadingIndicator";
import {persistor, store} from "./store";
import {ApolloProvider} from "@apollo/client";
import {client} from "./apollo";
import * as Sentry from "@sentry/react";

const root = ReactDOM.createRoot(document.getElementById('root'));

// Sentry.init({
//     dsn: "https://466c73250cf9917fdcac82d5dca40900@us.sentry.io/4506820747329536",
//     integrations: [
//         Sentry.browserTracingIntegration(),
//         Sentry.replayIntegration({
//             maskAllText: false,
//             blockAllMedia: false,
//         }),
//     ],
//     // Performance Monitoring
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

root.render(
    <ApolloProvider client={client}>
        <Provider store={store}>
            <PersistGate loading={<LoadingIndicator/>} persistor={persistor}>
                <BrowserRouter>
                    <Routing/>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </ApolloProvider>
);

